

export const escapeRegExp = (val: string) => {
    return val.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
}